import { render, staticRenderFns } from "./SaError.vue?vue&type=template&id=427a868c&scoped=true"
import script from "./SaError.vue?vue&type=script&lang=ts"
export * from "./SaError.vue?vue&type=script&lang=ts"
import style0 from "./SaError.vue?vue&type=style&index=0&id=427a868c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a868c",
  null
  
)

export default component.exports